"use client";

import { createContext, useContext } from "react";

export interface UserMenuContextValue {
  menuId: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const UserMenuContext = createContext<UserMenuContextValue | null>(null);

export const useUserMenu = (): UserMenuContextValue => {
  const ctx = useContext(UserMenuContext);
  if (!ctx) throw new Error("UserMenu parts must be used within <UserMenu>.");
  return ctx;
};
